/* SS size guide - tabs, marker highlight, sync with the Type/size buttons. SS/Claude 15.09.2026, label matching 21.09.2026.
   The guide markup is rendered server-side (snippets/ss-size-guide.liquid) and copied into <tool-tip> by theme.js on click.
   Without this file the guide still opens and reads fine; this only adds the conveniences. */
(function () {
  if (window.__ssSizeGuide) return;
  window.__ssSizeGuide = true;

  function pickerValue(index) {
    if (!index || index === '0') return '';
    var wrap = document.querySelector('.variant-input-wrap[data-index="option' + index + '"]');
    if (!wrap) return '';
    var r = wrap.querySelector('input[type="radio"]:checked');
    if (r) return (r.getAttribute('data-option-value') || r.value || '').trim();
    var s = wrap.querySelector('select');
    return s ? (s.value || '').trim() : '';
  }

  function select(root, role) {
    root.querySelectorAll('.ss-sg__tab').forEach(function (t) { t.classList.toggle('is-on', t.getAttribute('data-role') === role); });
    root.querySelectorAll('.ss-sg__pane').forEach(function (p) { p.classList.toggle('is-on', p.getAttribute('data-role') === role); });
  }

  // "Dame S", "Overall 1-2 år (86/92)", "Kids 6-12 Months" -> "S", "1-2 år", "6-12 Months": drop the (…) suffix, then a leading word without digits
  function shortLabel(s) { return (s || '').replace(/\s*\([^)]*\)\s*/g, ' ').trim().toLowerCase(); }
  function stripWord(s) { var w = s.split(/\s+/); return (w.length >= 2 && !/\d/.test(w[0])) ? w.slice(1).join(' ') : s; }
  function digitToken(s) { var t = s.split(/\s+/).filter(function (x) { return /\d/.test(x); }); return t[0] || ''; }
  // role = the pane matching the selected Type (family sets); rows in the other panes are never marked
  function markSize(root, role) {
    var sv = pickerValue(root.getAttribute('data-size-index'));
    root.querySelectorAll('tr.is-sel').forEach(function (tr) { tr.classList.remove('is-sel'); });
    var rows = Array.prototype.slice.call(root.querySelectorAll(role ? '.ss-sg__pane[data-role="' + role + '"] tr[data-size]' : 'tr[data-size]'));
    // kids fit blocks (overall / with cuffs / regular, SS 30.09.2026): mark the row only in the block of the chosen Type
    var tv = pickerValue(root.getAttribute('data-type-index')).toLowerCase();
    rows = rows.filter(function (tr) {
      var b = tr.closest('.ss-sg__block[data-type-value]');
      return !b || (b.getAttribute('data-type-value') || '').toLowerCase() === tv;
    });
    var svs = shortLabel(sv), svStrip = stripWord(svs), svd = digitToken(svStrip);
    var exact = sv ? rows.filter(function (tr) { return shortLabel(tr.getAttribute('data-size')) === svs; }) : [];
    rows.forEach(function (tr) {
      var a = shortLabel(tr.getAttribute('data-size'));
      var on = !!sv && (exact.length ? exact.indexOf(tr) >= 0
        : (stripWord(a) === svStrip || (!!svd && digitToken(stripWord(a)) === svd)));
      tr.classList.toggle('is-sel', on);
    });
  }


  function activate(root) {
    var tv = pickerValue(root.getAttribute('data-type-index'));
    var role = null;
    if (tv) {
      var tab = Array.prototype.find.call(root.querySelectorAll('.ss-sg__tab'), function (t) {
        // «|»-separated: the kids tab lists every kids Type value (Barn Overall|Barn Vanlig|Barn Løs)
        return (t.getAttribute('data-type-value') || '').toLowerCase().split('|').indexOf(tv.toLowerCase()) > -1;
      });
      if (tab) { role = tab.getAttribute('data-role'); select(root, role); }
    }
    markSize(root, role);
  }

  // kids fit buttons (SS 30.09.2026): one table at a time in the kids tab
  function selectFit(pane, line) {
    if (!pane || !line) return;
    pane.querySelectorAll('.ss-sg__fit').forEach(function (b) { b.classList.toggle('is-on', b.getAttribute('data-line') === line); });
    pane.querySelectorAll('.ss-sg__block--fit').forEach(function (b) { b.classList.toggle('is-on', b.getAttribute('data-line') === line); });
  }
  // open on the fit the customer chose (Type value of the selected variant)
  function fitFromPicker(root) {
    var tv = pickerValue(root.getAttribute('data-type-index')).toLowerCase();
    var pane = root.querySelector('.ss-sg__pane.has-fits.is-on') || root.querySelector('.ss-sg__pane.has-fits');
    if (!pane || !tv) return;
    var b = Array.prototype.find.call(pane.querySelectorAll('.ss-sg__fit'), function (x) { return (x.getAttribute('data-type-value') || '').toLowerCase() === tv; });
    if (b) selectFit(pane, b.getAttribute('data-line'));
  }

  function openRoot() { return document.querySelector('tool-tip[data-tool-tip="ss-size-guide"] [data-ss-sg]'); }

  document.addEventListener('tooltip:open', function (e) {
    if (!e.detail || e.detail.context !== 'ss-size-guide') return;
    setTimeout(function () { var root = openRoot(); if (root) { activate(root); fitFromPicker(root); } }, 0);
  });

  document.addEventListener('click', function (e) {
    var root = e.target.closest && e.target.closest('tool-tip[data-tool-tip="ss-size-guide"] [data-ss-sg]');
    if (!root) return;
    var fit = e.target.closest('.ss-sg__fit');
    if (fit) { selectFit(fit.closest('.ss-sg__pane'), fit.getAttribute('data-line')); return; }
    var tab = e.target.closest('.ss-sg__tab');
    if (tab) { select(root, tab.getAttribute('data-role')); return; }
    var n = e.target.closest('[data-m]');
    if (n) {
      var pane = n.closest('.ss-sg__pane'); var k = n.getAttribute('data-m');
      if (!pane || !k) return;
      if (pane.getAttribute('data-active') === k) pane.removeAttribute('data-active'); else pane.setAttribute('data-active', k);
    }
  });

  // keep the selected-size row in sync if the customer changes size while the guide is open
  document.addEventListener('change', function (e) {
    if (!e.target || !e.target.closest || !e.target.closest('.variant-input-wrap')) return;
    var root = openRoot(); if (root) { activate(root); fitFromPicker(root); }
  });
})();
